<template>
  <div class="container">
    <HeroSection :hero="heroSection" :register="register" />

    <Carousel2 :carousel="carousel2" />

    <USPS :benefit="benefit" />

    <Carousel :carousel="carousel" />

    <HowItWorks :steps="howItWork" />

    <Prices :pricing="pricing" />

    <Form :form="form" />

    <Aboutus :about="about" :register="register" />
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import Form from "@/components/Form.vue";
import Prices from "@/components/Prices.vue";
import USPS from "@/components/USPS.vue";
import Aboutus from "@/components/Aboutus.vue";
import Carousel from "@/components/Carousel.vue";
import Carousel2 from "@/components/Carousel2.vue";
import HowItWorks from "@/components/HowItWorks.vue";

export default {
  inheritAttrs: false,
  components: {
    HeroSection,
    Form,
    Prices,
    USPS,
    Aboutus,
    Carousel,
    Carousel2,
    HowItWorks,
  },
  props: {
    heroSection: Object,
    register: Object,
    pricing: Object,
    benefit: Object,
    carousel: Object,
    carousel2: Object,
    about: Object,
    form: Object,
    howItWork: Object,
  },
};
</script>

<style lang="scss"></style>
